module.exports = __webpack_public_path__ + "static/media/8. Procesos, Esmalte y oleo en tela, 140 X 180 cm.2020 copy.a253db09.png";